import { Grid, TextField } from '@mui/material'
import { useAppSelector } from './RunReduxHooks'
import { selectProcHeader } from './sliceRunProcHeader'

const dsx = {
    label: { WebkitTextFillColor: "black", fontSize: 22 },
    '& .MuiInputBase-input.Mui-disabled': { WebkitTextFillColor: 'black', fontWeight: 'bold', fontSize: 18 }
}

export default function UIAssessmentVentParametersDraeger() {
    const procHeader = useAppSelector(selectProcHeader)
    return (
        <Grid container spacing={1}>
            <Grid item xs={2}>
                <TextField sx={dsx} variant='standard' disabled value='100'
                    label={<>FiO<sub>2</sub> (%)</>} fullWidth />
            </Grid>
            <Grid item xs={2}>
                <TextField sx={dsx} variant='standard' disabled value={procHeader!.assessmentVV_mL!.toFixed(0)}
                    label='Assessment Tidal Volume (ml)' fullWidth />
            </Grid>
            <Grid item xs={2}>
                <TextField sx={dsx} variant='standard' disabled value='2.00'
                    label='Inspiratory Time (seconds)' fullWidth />
            </Grid>
            <Grid item xs={2}>
                <TextField sx={dsx} variant='standard' disabled value='10'
                    label='Respiratory Rate (bpm)' fullWidth />
            </Grid>
            <Grid item xs={2}>
                <TextField sx={dsx} variant='standard' disabled value='5'
                    label={<>PEEP (cm H<sub>2</sub>O)</>} fullWidth />
            </Grid>
            <Grid item xs={2}>
                <TextField sx={dsx} variant='standard' disabled value='As low as possible'
                    label='Flow' fullWidth />
            </Grid>
        </Grid>
    )
}